import { HTTPError } from 'services/api/entities';
import { Action, actionCreator } from '../../types';
import baseActionNames from './constants';

export const startAction = actionCreator<Action<unknown>>(
  baseActionNames.START_ACTION
);

export const stopAction = actionCreator<Action<unknown>>(
  baseActionNames.STOP_ACTION
);

export const errorAction = actionCreator<Action<HTTPError>>(
  baseActionNames.ERROR_ACTION
);

export const resetErrorAction = actionCreator<{ type: string }>(
  baseActionNames.RESET_ERROR_ACTION
);
